// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../../../Fields/FieldsImport';
import { FieldsFactory } from '../../../Factory/FieldsFactory';
export class AlgorithmHighLowInstrumentGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.ALGORITHM_HIGH_LOW_INSTRUMENT_GROUP, null, pfixFieldSet);
    }
    get RouteId() {
        return super.GetValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    get TradableId() {
        return super.GetValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
    }
    get InstrumentId() {
        return super.GetValue(FieldsFactory.FIELD_INSTRUMENT_ID);
    }
    get InstrumentName() {
        return super.GetValue(FieldsFactory.FIELD_NAME);
    }
    get InstrumentGroupId() {
        return super.GetValue(FieldsFactory.FIELD_INSTRUMENTTYPE_ID);
    }
    get InterestChange() {
        return super.GetValue(FieldsFactory.FIELD_INTEREST_CHANGE);
    }
    get AbsoluteChange() {
        return super.GetValue(FieldsFactory.FIELD_ABSOLUTE_CHANGE);
    }
    get LastPrice() {
        return super.GetValue(FieldsFactory.FIELD_LAST_PRICE);
    }
    get LastSize() {
        return super.GetValue(FieldsFactory.FIELD_LAST_SIZE);
    }
    get LastTradeDate() {
        return super.GetValue(FieldsFactory.FIELD_LAST_TRADE_DATE);
    }
    get MarketDataExchange() {
        return super.GetValue(FieldsFactory.FIELD_MD_EXCHANGE_NAME);
    }
    get TradingExchange() {
        return super.GetValue(FieldsFactory.FIELD_TRADING_EXCHANGE);
    }
    get Volume() {
        return super.GetValue(FieldsFactory.FIELD_VOLUME_TOTAL);
    }
    get HighLowEvent() {
        return super.GetValue(FieldsFactory.FIELD_HIGH_LOW_EVENT);
    }
    get High() {
        return super.GetValue(FieldsFactory.FIELD_HIGH);
    }
    get Low() {
        return super.GetValue(FieldsFactory.FIELD_LOW);
    }
}
